import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { Grid, Toolbar, Hidden, Box } from "@mui/material";
import { IconButton } from "@totalsoft/rocket-ui";
import MenuIcon from "@mui/icons-material/Menu";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ViewListIcon from "@mui/icons-material/ViewList";
import HeaderLinks from "./HeaderLinks";
import { withAreaSetter } from "../../providers/AreasConsumers";
import { areas } from "../../constants/areas";
import { AppBar } from "./LayoutStyles";

function Header({ miniActive, sidebarMinimize, handleDrawerToggle, setElemByAreaKey }) {
  const headerRef = useCallback(
    elem => {
      setElemByAreaKey(areas.header, elem);
    },
    [setElemByAreaKey]
  );

  return (
    <AppBar position="sticky">
      <Toolbar sx={{ paddingInline: ".75rem" }}>
        <Hidden mdDown>
          <Box pl="2">
            {miniActive ? (
              <IconButton id={"header_sidebarMinimizeBtn"} color="primary" variant="text" onClick={sidebarMinimize}>
                <ViewListIcon fontSize="small" />
              </IconButton>
            ) : (
              <IconButton id={"header_sidebarMinimizeBtn"} color="primary" variant="text" onClick={sidebarMinimize}>
                <MoreVertIcon fontSize="small" />
              </IconButton>
            )}
          </Box>
        </Hidden>
        <Grid container ref={headerRef}></Grid>
        <HeaderLinks />
        <Hidden mdUp>
          <IconButton
            color="primary"
            variant="text"
            aria-label="open drawer"
            onClick={handleDrawerToggle}
            sx={{ ml: 2 }}
          >
            <MenuIcon />
          </IconButton>
        </Hidden>
      </Toolbar>
    </AppBar>
  );
}

Header.propTypes = {
  miniActive: PropTypes.bool.isRequired,
  sidebarMinimize: PropTypes.func.isRequired,
  handleDrawerToggle: PropTypes.func.isRequired,
  handleRightDrawerToggle: PropTypes.func.isRequired,
  setElemByAreaKey: PropTypes.func.isRequired
};

export default withAreaSetter(Header);
